<div class="main-container">
  <router-outlet></router-outlet>

  <footer>
    <a>
      <img src="assets/images/consultame_client.png" alt="Muprespa consúltame"/>
    </a>
    <p class="copyright">&#169; Plexus {{currentYear}}</p>
    <p class="copyright">{{version}}</p>
  </footer>

</div>

